import { create } from 'zustand';
const useTranslations = create((set) => ({
    translations: {},
    setTranslations: (translations) => {
        set({ translations });
    },
}));
export default useTranslations;
